<template>
	<section id="Testimonials"
		class="relative pb-40 text-center"
		v-if="testimonials && testimonials.length && !isLoading">

		<div class="relative mt-32 grid overflow-x-hidden mx-auto lg:pl-5 lg:max-w-screen-lg">
			<div class="relative flex flex-nowrap justify-between duration-150 ease-in-out mb-14 w-max clearTransforms mx-auto lg:space-x-20 lg:max-w-screen-lg"
				:style="`transform: translateX(${leftPosition}px)`">
				<img v-for="(testimonial, index) in testimonials"
					:key="index"
					:src="testimonial.photo"
					loading="lazy"
					alt=""
					class="place-self-center align-middle cursor-pointer rounded-full"
					:width="highlightedIndex === testimonials.indexOf(testimonial) ? '10rem': '8rem'"
					:height="highlightedIndex === testimonials.indexOf(testimonial) ? '10rem': '8rem'"
					:class="highlightedIndex === testimonials.indexOf(testimonial) ? 'w-40': 'w-32 hidden lg:block'"
					@click="setHighlightedIndex(testimonials.indexOf(testimonial))" />

			</div>

			<p class="relative text-black text-xl max-w-xl mx-auto mb-5 w-11/12 font-extralight">
				<i class="absolute text-gold icon-quote -left-5 md:-left-11 -top-8 md:-top-5 transform rotate-180 text-2xl" />
				<span v-html="getTestimonial(testimonials[highlightedIndex], $i18n.locale)"></span>
			</p>

			<span class="text-gold text-md mx-auto font-extralight">
				{{ testimonials[highlightedIndex].name }} - {{ testimonials[highlightedIndex].role }}
			</span>
		</div>

		<div class="absolute text-black z-10 w-full lg:hidden grid grid-flow-col gap-x-10"
			style="top: 4.5rem;">
			<div class="float-left lg:ml-10 cursor-pointer"
				@click="previousHighlight">
				<i class="icon-left-open-big" />
			</div>

			<div class="float-right lg:mr-10 cursor-pointer"
				@click="nextHighlight">
				<i class="icon-right-open-big" />
			</div>
		</div>

	</section>

	<Spinner class="mt-40 mb-60"
		v-else-if="isLoading" />

	<div class="pb-40"
		v-else></div>
</template>

<script>
import Spinner from '@/components/Spinner'

export default {
	name: 'Testimonials',

	components: { Spinner },

	data: () => {
		return {
			leftPosition: 0,
			highlightedIndex: 0,
		}
	},

	computed: {
		testimonials() {
			return this.$store.state.App.testimonials
		},

		isLoading() {
			return this.$store.state.App.isLoadingTestimonials
		},

		getTestimonial() {
			return (v, locale) =>
				v['testimonial'][locale]
					? v['testimonial'][locale]
					: v.testimonial.en
		},
	},

	methods: {
		setHighlightedIndex(index) {
			if (index < 0 || index > this.testimonials.length - 1) return

			const scrollAmmount = 210

			if (index > this.highlightedIndex) {
				let value = (index - this.highlightedIndex) * scrollAmmount
				this.leftPosition -= value
			} else {
				let value = (this.highlightedIndex - index) * scrollAmmount
				this.leftPosition += value
			}

			this.highlightedIndex = index
		},

		previousHighlight() {
			if (this.highlightedIndex === 0)
				return this.setHighlightedIndex(this.testimonials.length - 1)

			return this.setHighlightedIndex(this.highlightedIndex - 1)
		},

		nextHighlight() {
			if (this.highlightedIndex === this.testimonials.length - 1)
				return this.setHighlightedIndex(0)

			return this.setHighlightedIndex(this.highlightedIndex + 1)
		},
	},

	created() {
		this.$store.dispatch('requestTestimonials').then(response => {
			if (response.data && response.data.length > 4)
				this.highlightedIndex = 2
		})
	},
}
</script>